import { render, staticRenderFns } from "./OfficeEditTemplate.vue?vue&type=template&id=421f034e"
import script from "./OfficeEditTemplate.vue?vue&type=script&lang=ts"
export * from "./OfficeEditTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports